import {
  CustomerKYBVerification,
  CustomerKYCVerification,
  CustomerKYXVerification,
  VerificationResult,
  VerificationStatus,
} from '@/types/customerKYXVerification';
import { Page } from '@/types/page';

const mockCustomerKYXVerifications: readonly CustomerKYXVerification[] = [
  // COMPLETED - 12 records
  {
    id: 'kyx-001',
    integratorId: 'int-001',
    type: 'INDIVIDUAL',
    firstName: 'John',
    lastName: 'Doe',
    sessionId: '1',
    verificationStatus: VerificationStatus.COMPLETED,
    verificationResult: VerificationResult.APPROVED,
    createdDate: '2025-01-15T10:30:00Z',
    createdBy: 'user-001',
  } as CustomerKYCVerification,
  {
    id: 'kyx-002',
    integratorId: 'int-001',
    type: 'BUSINESS',
    businessName: 'Acme Corporation',
    sessionId: '2',
    verificationStatus: VerificationStatus.COMPLETED,
    verificationResult: VerificationResult.APPROVED,
    createdDate: '2025-01-14T09:15:00Z',
    createdBy: 'user-002',
  } as CustomerKYBVerification,
  {
    id: 'kyx-003',
    integratorId: 'int-001',
    type: 'INDIVIDUAL',
    firstName: 'Jane',
    lastName: 'Smith',
    sessionId: '3',
    verificationStatus: VerificationStatus.COMPLETED,
    verificationResult: VerificationResult.APPROVED,
    createdDate: '2025-01-13T14:20:00Z',
    createdBy: 'user-003',
  } as CustomerKYCVerification,
  {
    id: 'kyx-004',
    integratorId: 'int-001',
    type: 'BUSINESS',
    businessName: 'Tech Solutions Ltd',
    sessionId: '4',
    verificationStatus: VerificationStatus.COMPLETED,
    verificationResult: VerificationResult.APPROVED,
    createdDate: '2025-01-12T11:45:00Z',
    createdBy: 'user-004',
  } as CustomerKYBVerification,
  {
    id: 'kyx-005',
    integratorId: 'int-001',
    type: 'INDIVIDUAL',
    firstName: 'Michael',
    lastName: 'Johnson',
    sessionId: '5',
    verificationStatus: VerificationStatus.COMPLETED,
    verificationResult: VerificationResult.APPROVED,
    createdDate: '2025-01-11T16:00:00Z',
    createdBy: 'user-005',
  } as CustomerKYCVerification,
  {
    id: 'kyx-006',
    integratorId: 'int-001',
    type: 'BUSINESS',
    businessName: 'Global Trade Inc',
    sessionId: '6',
    verificationStatus: VerificationStatus.COMPLETED,
    verificationResult: VerificationResult.APPROVED,
    createdDate: '2025-01-10T08:30:00Z',
    createdBy: 'user-006',
  } as CustomerKYBVerification,
  {
    id: 'kyx-007',
    integratorId: 'int-001',
    type: 'INDIVIDUAL',
    firstName: 'Sarah',
    lastName: 'Williams',
    sessionId: '7',
    verificationStatus: VerificationStatus.COMPLETED,
    verificationResult: VerificationResult.APPROVED,
    createdDate: '2025-01-09T13:10:00Z',
    createdBy: 'user-007',
  } as CustomerKYCVerification,
  {
    id: 'kyx-008',
    integratorId: 'int-001',
    type: 'BUSINESS',
    businessName: 'Innovate Labs',
    sessionId: '8',
    verificationStatus: VerificationStatus.COMPLETED,
    verificationResult: VerificationResult.APPROVED,
    createdDate: '2025-01-08T15:25:00Z',
    createdBy: 'user-008',
  } as CustomerKYBVerification,
  {
    id: 'kyx-009',
    integratorId: 'int-001',
    type: 'INDIVIDUAL',
    firstName: 'David',
    lastName: 'Brown',
    sessionId: '9',
    verificationStatus: VerificationStatus.COMPLETED,
    verificationResult: VerificationResult.APPROVED,
    createdDate: '2025-01-07T10:50:00Z',
    createdBy: 'user-009',
  } as CustomerKYCVerification,
  {
    id: 'kyx-010',
    integratorId: 'int-001',
    type: 'BUSINESS',
    businessName: 'Sunrise Enterprises',
    sessionId: '10',
    verificationStatus: VerificationStatus.COMPLETED,
    verificationResult: VerificationResult.APPROVED,
    createdDate: '2025-01-06T12:35:00Z',
    createdBy: 'user-010',
  } as CustomerKYBVerification,
  {
    id: 'kyx-011',
    integratorId: 'int-001',
    type: 'INDIVIDUAL',
    firstName: 'Emma',
    lastName: 'Davis',
    sessionId: '11',
    verificationStatus: VerificationStatus.COMPLETED,
    verificationResult: VerificationResult.APPROVED,
    createdDate: '2025-01-05T09:40:00Z',
    createdBy: 'user-011',
  } as CustomerKYCVerification,
  {
    id: 'kyx-012',
    integratorId: 'int-001',
    type: 'BUSINESS',
    businessName: 'Blue Ocean Partners',
    sessionId: '12',
    verificationStatus: VerificationStatus.COMPLETED,
    verificationResult: VerificationResult.APPROVED,
    createdDate: '2025-01-04T14:55:00Z',
    createdBy: 'user-012',
  } as CustomerKYBVerification,
  // PENDING - 2 records
  {
    id: 'kyx-013',
    integratorId: 'int-001',
    type: 'INDIVIDUAL',
    firstName: 'Robert',
    lastName: 'Martinez',
    sessionId: '13',
    verificationStatus: VerificationStatus.PENDING,
    verificationResult: VerificationResult.REVIEW,
    createdDate: '2025-01-03T11:20:00Z',
    createdBy: 'user-013',
  } as CustomerKYCVerification,
  {
    id: 'kyx-014',
    integratorId: 'int-001',
    type: 'BUSINESS',
    businessName: 'Future Vision Co',
    sessionId: '14',
    verificationStatus: VerificationStatus.PENDING,
    verificationResult: VerificationResult.REVIEW,
    createdDate: '2025-01-02T16:30:00Z',
    createdBy: 'user-014',
  } as CustomerKYBVerification,
  // FAILED - 2 records
  {
    id: 'kyx-015',
    integratorId: 'int-001',
    type: 'INDIVIDUAL',
    firstName: 'Lisa',
    lastName: 'Anderson',
    sessionId: '15',
    verificationStatus: VerificationStatus.FAILED,
    verificationResult: VerificationResult.DECLINED,
    createdDate: '2025-01-01T10:15:00Z',
    createdBy: 'user-015',
  } as CustomerKYCVerification,
  {
    id: 'kyx-016',
    integratorId: 'int-001',
    type: 'BUSINESS',
    businessName: 'Metro Services LLC',
    sessionId: '16',
    verificationStatus: VerificationStatus.FAILED,
    verificationResult: VerificationResult.DECLINED,
    createdDate: '2024-12-31T13:40:00Z',
    createdBy: 'user-016',
  } as CustomerKYBVerification,
  // NOT_STARTED - 2 records
  {
    id: 'kyx-017',
    integratorId: 'int-001',
    type: 'INDIVIDUAL',
    firstName: 'Thomas',
    lastName: 'Wilson',
    sessionId: '17',
    verificationStatus: VerificationStatus.NOT_STARTED,
    verificationResult: VerificationResult.UNKNOWN,
    createdDate: '2024-12-30T08:25:00Z',
    createdBy: 'user-017',
  } as CustomerKYCVerification,
  {
    id: 'kyx-018',
    integratorId: 'int-001',
    type: 'BUSINESS',
    businessName: 'Prime Logistics',
    sessionId: '18',
    verificationStatus: VerificationStatus.NOT_STARTED,
    verificationResult: VerificationResult.UNKNOWN,
    createdDate: '2024-12-29T15:50:00Z',
    createdBy: 'user-018',
  } as CustomerKYBVerification,
];

export const createMockCustomerKYXVerificationsPage = (
  page: number = 0,
  size: number = 10,
): Page<CustomerKYXVerification> => {
  const startIndex = page * size;
  const endIndex = startIndex + size;
  const content = mockCustomerKYXVerifications.slice(startIndex, endIndex);

  return {
    content,
    pageable: {
      pageNumber: page,
      pageSize: size,
    },
    totalElements: mockCustomerKYXVerifications.length,
    totalPages: Math.ceil(mockCustomerKYXVerifications.length / size),
    last: endIndex >= mockCustomerKYXVerifications.length,
    first: page === 0,
    numberOfElements: content.length,
    size,
    sort: {
      sorted: false,
      empty: true,
      unsorted: true,
    },
    empty: content.length === 0,
  };
};

export const getMockCustomerKYXVerification = (id: string): CustomerKYXVerification | undefined => {
  return mockCustomerKYXVerifications.find(
    (customer: CustomerKYXVerification): boolean => customer.id === id,
  );
};

export { mockCustomerKYXVerifications };
